// extracted by mini-css-extract-plugin
export var disabled = "_s0-0";